import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const env = import.meta.env;

// Required environment variables (set in .env.local and at build time):
//   VITE_COGNITO_REGION         e.g. us-east-1
//   VITE_COGNITO_USER_POOL_ID   e.g. us-east-1_AbCdEfGhI
//   VITE_COGNITO_CLIENT_ID      e.g. 1abc23def456ghi789jklmnop
//   VITE_COGNITO_DOMAIN         e.g. accuryn-sales.auth.us-east-1.amazoncognito.com
//   VITE_APP_BASE_URL           e.g. https://dxxxxx.cloudfront.net  or http://localhost:5173
//   VITE_API_BASE_URL           API Gateway invoke URL

export const config = {
  region: env.VITE_COGNITO_REGION ?? "us-east-1",
  userPoolId: env.VITE_COGNITO_USER_POOL_ID ?? "",
  clientId: env.VITE_COGNITO_CLIENT_ID ?? "",
  cognitoDomain: env.VITE_COGNITO_DOMAIN ?? "",
  // Always derive from the browser origin so the SPA works at any URL
  // (CloudFront default, sales.accuryn.com, localhost) without rebuilds.
  appBaseUrl: window.location.origin,
  apiBaseUrl: env.VITE_API_BASE_URL ?? "",
};

const authority = `https://cognito-idp.${config.region}.amazonaws.com/${config.userPoolId}`;

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: config.clientId,
  redirect_uri: `${config.appBaseUrl}/callback`,
  response_type: "code",
  scope: "openid email profile",
  post_logout_redirect_uri: `${config.appBaseUrl}/`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Sign out at the Cognito hosted UI when user logs out
  metadataSeed: {
    end_session_endpoint: `https://${config.cognitoDomain}/logout?client_id=${config.clientId}&logout_uri=${encodeURIComponent(`${config.appBaseUrl}/`)}`,
  },
  onSigninCallback: () => {
    // Clean ?code=&state= from URL after sign-in
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
